import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MagnifyingGlass } from "@phosphor-icons/react";

export const LoadNumberSearch = () => {
  const nav = useNavigate();
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async () => {
    if (!q.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.get("/loads/find-by-number", { params: { number: q } });
      if (!data.length) { toast.error(`No load found for "${q.trim()}"`); return; }
      const l = data[0];
      toast.success(`MFG-${l.load_number}: ${l.lane}${l.carrier_name ? ` · ${l.carrier_name}` : ""}${l.can_edit ? "" : " · view only"}`);
      if (user?.is_sandbox) {
        try {
          const k = `mfg_demo_visits_${user.id}`;
          const v = JSON.parse(localStorage.getItem(k) || "{}");
          if (!v.search) { v.search = true; localStorage.setItem(k, JSON.stringify(v)); }
        } catch { /* noop */ }
      }
      setQ("");
      nav(`/portal/loads/${l.id}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Search failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative mb-3" data-testid="load-number-search">
      <MagnifyingGlass size={13} weight="bold" className="absolute left-2.5 top-1/2 -translate-y-1/2 text-white/30" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") go(); }}
        placeholder="Find load # (MFG-0126)"
        disabled={busy}
        data-testid="load-number-search-input"
        className="w-full bg-white/5 border border-white/10 rounded-md pl-8 pr-2 py-1.5 text-xs text-white placeholder-white/30 focus:outline-none focus:border-[#0A84FF]"
      />
    </div>
  );
};
